// Component: الباقات
import { useLanguage } from "../../../i18n/LanguageContext";


export default function PackagesSelector({ selectedPackage, onChange }) {
  const { t } = useLanguage();

  return (
    <div className="request-packages-box">

      {/* العنوان */}
      <label className="request-label">
        {t.request.labels.package}
      </label>

      {/* الباقات */}
      {t.request.packages.map((pkg, index) => (
        <label key={index} className="request-option">
          <input
            type="radio"
            name="selectedPackage"
            value={pkg}
            checked={selectedPackage === pkg}
            onChange={onChange}
          />
          {pkg}
        </label>
      ))}

    </div>
  );
}

